import { render, staticRenderFns } from "./AppsConfig.vue?vue&type=template&id=4444519b"
import script from "./AppsConfig.vue?vue&type=script&lang=js"
export * from "./AppsConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\_ASNET\\01_projects\\05_chatannie\\01_git\\chatbot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4444519b')) {
      api.createRecord('4444519b', component.options)
    } else {
      api.reload('4444519b', component.options)
    }
    module.hot.accept("./AppsConfig.vue?vue&type=template&id=4444519b", function () {
      api.rerender('4444519b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/AppsConfig/AppsConfig.vue"
export default component.exports